var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83594 16C7.40374 16 7.89794 15.6845 8.15254 15.2192C8.35144 14.8559 8.67174 14.5 9.08594 14.5C9.50014 14.5 9.84554 14.841 9.74334 15.2424C9.41294 16.5402 8.23654 17.5 6.83594 17.5C5.43534 17.5 4.2589 16.5402 3.92851 15.2424C3.82632 14.841 4.17173 14.5 4.58594 14.5C5.00014 14.5 5.32044 14.8559 5.51934 15.2192C5.77394 15.6845 6.26814 16 6.83594 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1602 12.5L11.3909 5.57679C11.133 3.25587 9.17133 1.5 6.83613 1.5C4.50088 1.5 2.53911 3.25587 2.28123 5.57679L1.51199 12.5H12.1602ZM6.83613 0C3.73656 0 1.13269 2.33057 0.790414 5.41114L0.0087235 12.4463C-0.0833665 13.2752 0.565404 14 1.3993 14H12.2728C13.1067 14 13.7555 13.2752 13.6634 12.4463L12.8817 5.41114C12.5395 2.33057 9.93563 0 6.83613 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notificationBell.b1ba1600ddb3c30bf29526470772aa57.svg";
export { ForwardRef as ReactComponent };